type CallbackOnMove = (position: number) => void
type CallbackOnStart = () => void
type CallbackOnEnd = () => void

export class DraggableSlider {

    private startX: number;
    private startValue: number;
    private trackWidth: number;
    private currentPosition: number = 50;

    private element: HTMLElement;

    private onStart: CallbackOnStart;
    private onMove: CallbackOnMove;
    private onEnd: CallbackOnEnd;

    public constructor(element: HTMLElement, trackWidth: number, onStart: CallbackOnStart, onMove: CallbackOnMove, onEnd: CallbackOnEnd) {
        this.element = element;
        this.trackWidth = trackWidth;
        this.onStart = onStart;
        this.onMove = onMove;
        this.onEnd = onEnd;

        this.element.addEventListener("mousedown", this.handleStart);
        this.element.addEventListener("touchstart", this.handleStart);
        this.element.addEventListener("keydown", this.handleKeydown);
    }

    public handleStart = (event: Event): void => {
        this.onStart();
        this.startValue = this.currentPosition;

        if (event instanceof MouseEvent) {
            this.startX = event.clientX;
            document.addEventListener("mousemove", this.handleMove);
            document.addEventListener("mouseup", this.handleEnd);
        } else if (event instanceof TouchEvent) {
            this.startX = event.touches[0].clientX;
            document.addEventListener("touchmove", this.handleMove);
            document.addEventListener("touchend", this.handleEnd);
        }
    };

    private handleMove = (event: Event): void => {
        let deltaX = 0;
        if (event instanceof MouseEvent) {
            deltaX = event.clientX - this.startX;
        } else if (event instanceof TouchEvent) {
            deltaX = event.touches[0].clientX - this.startX;
        }

        const deltaPercent = (deltaX / this.trackWidth) * 100;

        this.currentPosition = Math.max(0, Math.min(100, this.startValue + deltaPercent));
        this.onMove(this.currentPosition);
    };

    private handleEnd = (): void => {
        this.onEnd();
    };

    public destroy(): void {
        document.removeEventListener("mousemove", this.handleMove);
        document.removeEventListener("mouseup", this.handleEnd);
        document.removeEventListener("touchmove", this.handleMove);
        document.removeEventListener("touchend", this.handleEnd);

        this.element.removeEventListener("mousedown", this.handleStart);
        this.element.removeEventListener("touchstart", this.handleStart);
        this.element.removeEventListener("keydown", this.handleKeydown);
    }

    private handleKeydown = (event: KeyboardEvent): void => {
        const step = 5;
        switch (event.key) {
            case "ArrowLeft":
                event.preventDefault();
                this.currentPosition = Math.max(0, this.currentPosition - step);
                this.onMove(this.currentPosition);
                return;
            case "ArrowRight":
                event.preventDefault();
                this.currentPosition = Math.min(100, this.currentPosition + step);
                this.onMove(this.currentPosition);
                return;
            case "Enter":
            case " ":
                event.preventDefault();
                this.element.blur();
                this.onEnd();
                return;
            default:
                return;
        }
    };
}